import { put, takeEvery, call, fork, select } from 'redux-saga/effects';

import MixPanel from 'mixpanel-browser';
import SagaUtils from 'Utils/SagaUtils';
import { ProfileActions } from './actions';
import ApiService from '../../../Services/ApiService';
import { displayNotification } from '../../../Utils/GenericUtils';
import AppConfig from '../../../Config/AppConfig';

export function* changeProfileDetails(action) {
  try {
    const profileDetails = yield call(ApiService.changeProfileDetails, action.payload);
    yield put(ProfileActions.changeProfileDetailsSucceeded(profileDetails));
    displayNotification('success', 'Success', 'Name was updated successfully');
  } catch (e) {
    yield put(ProfileActions.changeProfileDetailsFailed(e.response.data));
    displayNotification('error', 'Error', 'Error updating name');
  }
}

export function* changePassword(action) {
  try {
    const profileDetails = yield call(ApiService.changePassword, action.payload);
    yield put(ProfileActions.changePasswordSucceeded(profileDetails));
    displayNotification('success', 'Success', 'Password was updated successfully');
    const permittedSearch = yield select((state) => state.app.permittedApps.search);
    const permittedApi = yield select((state) => state.app.permittedApps.api);
    if (permittedSearch) {
      window.location.href = `/search/`;
    } else if (permittedApi) {
      window.location.href = `/api/`;
    } else {
      window.location.href = `/${AppConfig.ACCOUNTS_PREFIX}manage-users/users/`;
    }
  } catch (e) {
    yield put(ProfileActions.changePasswordFailed(e.response.data));
    displayNotification('error', 'Error', 'Error updating password');
  }
}

export function* setPassword(action) {
  try {
    const res = yield call(ApiService.setPassword, action.payload);
    yield put(ProfileActions.setPasswordSucceeded(res.data));

    let effectiveUrl = res.data.redirect_url || `/${AppConfig.ACCOUNTS_PREFIX}login/`;

    if (effectiveUrl.includes('/login/pipl/?next')) {
      effectiveUrl = `/${AppConfig.ACCOUNTS_PREFIX}login/`;
    }

    window.location.href = effectiveUrl;
  } catch (e) {
    yield put(ProfileActions.setPasswordFailed(e.response.data));
    displayNotification('error', 'Error', 'Error setting password');
  }
}

export function* fetchProfileDetails() {
  try {
    const profileDetails = yield call(ApiService.getProfileDetails);
    yield put(ProfileActions.profileDetailsFetchSucceeded(profileDetails));
  } catch (e) {
    yield put(ProfileActions.profileDetailsFetchFailed(e.response.data));
  }
}

export function* checkIsInvited() {
  try {
    const invites = yield call(ApiService.getUserInvites);

    yield put(ProfileActions.checkIsInvitedSucceeded(invites));
  } catch (e) {
    yield put(ProfileActions.checkIsInvitedFailed(e.response.data));
  }
}

export function* moveAccount(action) {
  try {
    const inviteId = action.payload;
    yield call(ApiService.acceptInvite, { inviteId });
    window.location.reload();

    yield put(ProfileActions.moveAccountSucceeded());
    displayNotification('success', 'Success', 'Account moved successfully');
  } catch (e) {
    yield put(ProfileActions.moveAccountFailed(e.response.data));
    displayNotification('error', 'Error', 'Error moving account');
  }
}

export function* rejectInvite(action) {
  try {
    const inviteId = action.payload;

    yield call(ApiService.rejectInvite, { inviteId });
    yield put(ProfileActions.rejectInviteSucceeded());
    displayNotification('success', 'Success', 'Rejected Invite Successfully');
  } catch (e) {
    yield put(ProfileActions.rejectInviteFailed(e?.response?.data));
    displayNotification('error', 'Error', 'Error rejecting the invite');
  }
}

function* load() {
  yield put(ProfileActions.profileDetailsFetch());
}

function* onProfileFetched(action) {
  try {
    const profile = action.payload;

    MixPanel.register({
      first_name: profile.first_name,
      last_name: profile.last_name,
      email: profile.email,
    });
    MixPanel.track('Profile Loaded');
  } catch (e) {
    console.log(e);
  }
}

export function* watchProfile() {
  yield SagaUtils.allIfLogged([
    takeEvery(ProfileActions.rejectInvite, rejectInvite),
    takeEvery(ProfileActions.profileDetailsFetchSucceeded, onProfileFetched),
    takeEvery(ProfileActions.profileDetailsFetch, fetchProfileDetails),
    takeEvery(ProfileActions.changeProfileDetails, changeProfileDetails),
    takeEvery(ProfileActions.changePassword, changePassword),
    takeEvery(ProfileActions.checkIsInvited, checkIsInvited),
    takeEvery(ProfileActions.moveAccount, moveAccount),
    fork(load),
  ]);
  yield takeEvery(ProfileActions.setPassword, setPassword);
}
